<template>
  <div>
    <CouponSkeleton v-if="isLoadingCoupon" />
    <div class="my-coupon" v-else :class="isH5 ? 'my-coupon-bottom' : ''">
      <p class="my-back" @click="handelBack" v-if="!isH5">
        <i class="el-icon-arrow-left" />
        {{ $t('FoodC_supplement_Return_wVpv') }}
      </p>
      <div v-if="(couponData && couponData.length > 0) || isUnCoupon || isH5">
        <div class="coupon-wrapper">
          <!-- 兑换码 -->
          <!-- <CouponCode /> -->
          <List
            v-if="isInit"
            :disabled="disabled"
            :auto-load="autoLoad"
            :distance="distance"
            :load-more-status="loadMoreStatus"
            @more="getCouponList"
          >
            <el-row :gutter="10" class="shop-list-wrapper">
              <el-col :xs="24" :sm="8">
                <CouponCode class="coupon-card" @update="getInit" />
              </el-col>
              <el-col
                :xs="24"
                :sm="8"
                v-for="(coupon, index) in couponData"
                :key="'shop' + index"
                class="coupon-col"
              >
                <!-- 可用优惠券 -->
                <soda-coupon-cell
                  class="coupon-content"
                  :key="index"
                  :index="index"
                  :isUseLink="true"
                  :couponSrc="coupon"
                  :selectable="false"
                  :country="country"
                  :isMoreTip="!isH5"
                  :openedCityList="openedCityList"
                  backgroundColor="#F5F5F7"
                  theme="useCell"
                  :from="2"
                  @handleUse="handleUse(coupon, index)"
                ></soda-coupon-cell>
              </el-col>
            </el-row>
          </List>
        </div>
        <!-- 分割线 -->
        <SpiltLine
          class="coupon-line"
          :title="'Expired Coupons'"
          v-if="!isH5 && isUnCoupon"
        />
        <!-- 不可用券 -->
        <CouponUnavailable v-if="!isH5" />
        <!-- 无效券 -->
        <div v-if="isH5 && isUnCoupon" class="coupon-exipred">
          <a href="javascript:;" @click="goToExipred"
            >{{ $t('无效券') }}<i class="el-icon-arrow-right"></i
          ></a>
        </div>
      </div>
      <!-- 没有优惠券 -->
      <div
        v-if="
          !isLoadingCoupon && !isUnCoupon && couponData && isCouponNone && !isH5
        "
        class="coupon—none-bottom"
      >
        <NoList
          :noImg="NoCoupon"
          :noText="$t('暂无优惠券')"
          class="no-list-coupon"
        />
        <CouponCode class="coupon-card" @update="getInit" />
      </div>
    </div>
  </div>
</template>

<script>
import CouponCode from '@/components/Coupon/couponCode.vue';
import SpiltLine from '@/components/SpiltLine';
import List from '@/components/List';
import { mapState, mapActions } from 'vuex';
import { getLanguageLong } from '@didi/gettext';
import CouponSkeleton from '@/components/SkeletonComponents/couponSkeleton/couponSkeleton';
import CouponUnavailable from './couponUnavailable.vue';
import NoList from '@/components/NoList';
import NoCoupon from '@/assets/images/didi/new_no_coupon.png';
import { GLOBAL_ADDRESS_CHANGE, eventBus } from '@/utils/eventBus';
export default {
  name: 'MyCoupon',
  components: {
    CouponCode,
    List,
    CouponSkeleton,
    SpiltLine,
    CouponUnavailable,
    NoList,
  },
  data() {
    return {
      NoCoupon: NoCoupon,
      isLoadingCoupon: true,
      disabled: false,
      distance: 30,
      autoLoad: false,
      isUnCoupon: false,

      loadMoreStatus: 'nomore', // 加载状态 suc fail nomore loading
      loadMoreStatusRem: 'nomore',
      couponData: [],
      currentPage: 1, // 标识当前展示券列表的第几页

      size: 5,
      isInit: false,
      isLastPage: false, // 标识是否已翻到最后一页
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      openedCityList: ({ common }) => common.openedCityList,
      country: ({ common }) => common.country,
    }),
    isCouponNone() {
      return this.couponData?.length === 0;
    },
  },
  async mounted() {
    this.$trackEvent({
      eventId: 'sailing_c_x_landing_coupon_center_sw',
      eventLabel: '优惠券中心页面曝光',
    });

    await this.getInit();
    this.isInit = true;
    eventBus.$on(GLOBAL_ADDRESS_CHANGE, () => {
      this.getInit();
    });
    // this.unGetCouponList();
  },
  methods: {
    ...mapActions('coupon', ['getWalletCoupons']),
    /** @desc 返回上一层 **/
    handelBack() {
      this.$router.go(-1);
    },
    async getInit() {
      this.isLoadingCoupon = true;
      this.couponData = [];
      this.currentPage = 1;
      await this.getUnCouponList();
      await this.getCouponList();
      this.isLoadingCoupon = false;
    },
    /** @desc 可用券 **/
    async getCouponList() {
      this.loadMoreStatus = 'loading';
      this.loadMoreStatusRem = 'loading';

      const res = await this.getWalletCoupons({
        utc_offset: 0 - new Date()?.getTimezoneOffset(),
        expire_flag: 6,
        page: this.currentPage,
        lang: getLanguageLong(),
        size: this.currentPage === 1 ? this.size : 9,
      });
      this.currentPage++;
      if (res?.couponList) {
        this.couponData = this.couponData.concat(res?.couponList);
      }
      this.loadMoreStatus = res?.next ? 'suc' : 'nomore';
      this.loadMoreStatusRem = res?.next ? 'suc' : 'nomore';
    },

    /** @desc 不可用券 **/
    async getUnCouponList() {
      const res = await this.getWalletCoupons({
        utc_offset: 0 - new Date()?.getTimezoneOffset(),
        expire_flag: 2,
        page: 1,
        lang: getLanguageLong(),
        size: 1,
      });
      this.isUnCoupon = res?.couponList?.length > 0;
    },

    /** @desc 跳转至已过期券 **/
    goToExipred() {
      this.$router.push('/user/coupon/unavailable/');
    },
  },
  destroyed() {
    eventBus.$off(GLOBAL_ADDRESS_CHANGE);
  },
};
</script>
<style lang="scss">
.no-list-coupon {
  margin-bottom: 30px;
  .no-list_icon {
    width: 200px !important;
    height: 200px !important;
  }
}
@media screen and (max-width: 768px) {
  .no-list-coupon {
    margin-bottom: rem(60);
    .no-list_icon {
      width: rem(300) !important;
      height: rem(300) !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.my-coupon {
  width: 1162px;
  margin: 0 auto;
  .coupon—none-bottom {
    padding-bottom: 150px;
  }
  .coupon-line {
    width: 300px;
    margin: 0 auto 20px auto;
  }
  .my-back {
    font-family: 'Aspira Medium';
    font-weight: 500;
    font-size: 20px;
    line-height: 60px;
  }
  // .coupon-col {
  //   position: relative;
  //   z-index: 9;
  // }
  .coupon-content {
    width: 372px;
    margin-bottom: 20px;
  }
  .coupon-card {
    width: 372px;
    height: 135px;
    box-sizing: border-box;
    padding: 30px 0 36px 0;
    background: #ffffff;
    border-radius: 8px;
  }
  .grey {
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
  }
}
@media screen and (max-width: 768px) {
  .my-coupon-bottom {
    padding: rem(24) 0 rem(160) 0;
  }
  .my-coupon {
    width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    .coupon-card {
      width: rem(702);
      max-width: rem(700);
      height: unset;
      box-sizing: border-box;
      padding: 0;
      background: unset;
      border-radius: 8px;
      margin-bottom: 20px;
    }
    .coupon-content {
      width: rem(702);
      margin-bottom: 20px;
    }
    .coupon-exipred {
      position: fixed;
      padding: rem(60) 0;
      width: 100%;
      bottom: 0;
      display: flex;
      background: #fff;
      justify-content: center;
      font-size: rem(32);
      box-shadow: 0 rem(4) rem(64) 0 rgba(117, 117, 117, 0.24);
      z-index: 1;
      a {
        font-family: 'Aspira Light';
        color: #000;
      }
    }
  }
}
</style>
